import React from "react";
import { motion, AnimatePresence } from "framer-motion";

/* data imports */
import picnicAppliancesImagesObj from "../game-data/picnicAppliancesImagesObj";

/* animation imports */
import { elementsEntryExit } from "../../assets/js/animations";

const AppliancesWrapper = ({
  dishTypeHandler,
  dishType,
  calculateIsActive,
}) => {
  return (
    <div className="appliances-wrapper">
      <AnimatePresence>
        <motion.div
          layout
          className={`appliance ${
            dishType === "pizza"
              ? "active"
              : dishType !== "" && dishType !== "pizza"
              ? "disabled"
              : ""
          }`}
          onClick={() => {
            dishTypeHandler("pizza");
          }}
          variants={elementsEntryExit}
          initial="initial"
          animate="animate"
          exit="exit"
          key="pizza"
        >
          <div className="appliance-img">
            {dishType === "pizza" && !calculateIsActive ? (
              <img
                src={picnicAppliancesImagesObj["ovenOpen"]}
                alt="Dish Type pizza"
              />
            ) : dishType === "pizza" && calculateIsActive ? (
              <img
                src={picnicAppliancesImagesObj["ovenBaking"]}
                alt="Dish Type pizza"
              />
            ) : (
              <img
                src={picnicAppliancesImagesObj["ovenClosed"]}
                alt="Dish Type pizza"
              />
            )}
          </div>
        </motion.div>
        <motion.div
          layout
          className={`appliance ${
            dishType === "pasta"
              ? "active"
              : dishType !== "" && dishType !== "pasta"
              ? "disabled"
              : ""
          }`}
          onClick={() => {
            dishTypeHandler("pasta");
          }}
          variants={elementsEntryExit}
          initial="initial"
          animate="animate"
          exit="exit"
          key="pasta"
        >
          <div className="appliance-img">
            {dishType === "pasta" && !calculateIsActive ? (
              <img
                src={picnicAppliancesImagesObj["stove"]}
                alt="Dish Type pasta"
              />
            ) : dishType === "pasta" && calculateIsActive ? (
              <img
                src={picnicAppliancesImagesObj["pastaCooking"]}
                alt="Dish Type pasta"
              />
            ) : (
              <img
                src={picnicAppliancesImagesObj["pastaPan"]}
                alt="Dish Type pasta"
              />
            )}
          </div>
        </motion.div>
        <motion.div
          layout
          className={`appliance ${
            dishType === "burger"
              ? "active"
              : dishType !== "" && dishType !== "burger"
              ? "disabled"
              : ""
          }`}
          onClick={() => {
            dishTypeHandler("burger");
          }}
          variants={elementsEntryExit}
          initial="initial"
          animate="animate"
          exit="exit"
          key="burger"
        >
          <div className="appliance-img">
            {dishType === "burger" && !calculateIsActive ? (
              <img
                src={picnicAppliancesImagesObj["grillerOpen"]}
                alt="Dish Type burger"
              />
            ) : dishType === "burger" && calculateIsActive ? (
              <img
                src={picnicAppliancesImagesObj["grillerGrilling"]}
                alt="Dish Type burger"
              />
            ) : (
              <img
                src={picnicAppliancesImagesObj["grillerClosed"]}
                alt="Dish Type burger"
              />
            )}
          </div>
        </motion.div>
        <motion.div
          layout
          className={`appliance ${
            dishType === "smoothie"
              ? "active"
              : dishType !== "" && dishType !== "smoothie"
              ? "disabled"
              : ""
          }`}
          onClick={() => {
            dishTypeHandler("smoothie");
          }}
          variants={elementsEntryExit}
          initial="initial"
          animate="animate"
          exit="exit"
          key="smoothie"
        >
          <div className="appliance-img">
            {dishType === "smoothie" && !calculateIsActive ? (
              <img
                src={picnicAppliancesImagesObj["blenderMachine"]}
                alt="Dish Type Smoothie"
              />
            ) : dishType === "smoothie" && calculateIsActive ? (
              <img
                src={picnicAppliancesImagesObj["blenderBlending"]}
                alt="Dish Type Smoothie"
              />
            ) : (
              <img
                src={picnicAppliancesImagesObj["blender"]}
                alt="Dish Type Smoothie"
              />
            )}
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default AppliancesWrapper;
